import script from "./BaseItemDialogModifiers.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseItemDialogModifiers.vue?vue&type=script&setup=true&lang=ts"

import "./BaseItemDialogModifiers.vue?vue&type=style&index=0&id=7f6f9d61&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f6f9d61"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QExpansionItem,QSpinner,QItem});
